//--------------------------------------------
//
// Chat Messages
//
//--------------------------------------------

import TextExplode from './TextExplode';
import AudioManager from './AudioManager';


const CHATTERS = [
	{
		name: 'Mark',
		img: 'img/zuck.png',
		greeting: 'Mark wants to talk to you!',
		message: 'Hi! Hope you can check out the feature below where I talk about Facebook’s future with the Oculus Rift. TTL!'
	},
	{
		name: 'Palmer',
		img: 'img/palmer.png',
		greeting: 'Palmer wants to chat with you!',
		message: 'Heyo! Check out the article below where I talk about my role in the creation of the Oculus! TTL!'
	}
];


//--------------------------------------------
// Class
//
		
class ChatMessage {

	constructor(threeScene){

		//rate at which this slides out yo
		this.initialSpeed = 5000;
		
		this.outerContainer = document.getElementById('chatWrapper');
		//pick a random chatter
		this.chatter = CHATTERS[Math.floor(Math.random() * CHATTERS.length)];
		
		//initially inactive
		this.chatting = false;
		this.active = false;

		//reference to underlying skybox scene
		this.threeScene = threeScene;

		

		//chat message frontside
		this.container = null;

		//chat message backside
		this.textContainer = null;

		this.init();
	}

	init(){
		//layout DOM
		this.renderDom();
		this.addListeners();
		this.activate();
	}

	//--------------------------------------------
	// Render out structure
	//	
	renderDom(){
		const self = this;
		//Add chat request div
		this.container = document.createElement('div');
		this.container.classList.add('chat-frontside');
		this.outerContainer.appendChild(this.container);

		//load + add chat image
		this.image = new Image();

		this.image.onload = () => {
			const imageContainer = document.createElement('div');
			imageContainer.classList.add('chat-image');
			imageContainer.style.background = `url(${self.image.src}) no-repeat center center`;
			imageContainer.style.backgroundSize = 'contain';
			self.container.appendChild(imageContainer);
			

			//add Text
			self.greetingContainer = document.createElement('div');
			self.greetingContainer.classList.add('chat-text');
			self.greetingContainer.textContent = self.chatter.greeting;
			self.container.appendChild(self.greetingContainer);


			//add backside w/ chat text
			self.textContainer = document.createElement('div');
			self.textContainer.classList.add('chat-backside');

			const paragraph = document.createElement('p');
			paragraph.textContent = self.chatter.message;


			const icon = document.createElement('img');
			icon.src = self.image.src;

			self.textContainer.appendChild(icon);
			self.textContainer.appendChild(paragraph);
			self.outerContainer.appendChild(self.textContainer);
		}

		this.image.src = this.chatter.img;
	}


	//--------------------------------------------
	// Add Listeners
	//
	addListeners(){
		this.outerContainer.addEventListener('click', this.onClick.bind(this), false);
	}


	onClick(){
		const self = this;

		if (!this.chatting){
			this.threeScene.addSprites(this.image.src);
			this.outerContainer.classList.add('chatting');
			this.chatting = true;
			TextExplode('OK!');
			AudioManager.onMessageTurn();
		}
		
		
		else{
			
			this.destroy();
			TextExplode('See ya!');
			AudioManager.onMessageOff();
		}
		
	}

	activate(){
		const self = this;
		this.activateTimer = setTimeout(() => {

			if (!self.active){
				self.outerContainer.classList.add('active');
				AudioManager.onMessage();
				self.active = true;
			}

			else{
				self.activate();
			}
			
		}, this.initialSpeed);
	}


	//--------------------------------------------
	// Return element
	//
			
	el(){
		return this.outerContainer;
	}


	//--------------------------------------------
	// Destroy inner chat
	//
	destroy(){
		const self = this;

		this.chatting = false;
		this.outerContainer.classList.remove('chatting');
		this.outerContainer.classList.remove('active');

		clearTimeout(this.activateTimer);

		setTimeout(() => {
			self.container.remove();
			self.textContainer.remove();

			self.container = null;
			self.textContainer = null;

		}, 1000);
	}
			



}

export default ChatMessage;